import {
    Aboutus,
    ReferFriend,
    AmbassadorIcon,
    BlogsIcon,
    GiftCard,
    ShoppingBag,
    ShoppableSection,
    InviteFriend,
    JoinOurAmbassadors,
    StyleMyWardrobe,
    StyledBoxes,
    ExploreNow,
    ShoppableSessions,
} from "../../../public/Theme";
export const OPEN_MAIN_MENU = "Open main menu";
export const CLOSE_MENU_TEXT = "Close menu";
export const LOGO_ALT_TEXT = "Wearthat Logo";
export const LOGIN_ENDPOINT = "/login";
export const GIFT_CARD_ENDPOINT = "/gift-card/";
export const DRAWER_NAVIGATION = "drawer-navigation";
export const HEADER_LOGO_IMAGE_ID = "header_logo_img_id";
export const HEADER_BUTTON_ID = "header_button_id";
export const COUNTRY_ICON_ALT = "country-icon";
export const BACK_TEXT = "BACK";
export const AR = "AR";
export const EN = "EN";
export const HEADER_LINK = [
    {
        link: `/about-us`,
        text: "About Us",
        src: Aboutus,
        flyout_links: null,
    },
    {
        text: "Style Services",
        flyout_links: [
            {
                link: "/styled-boxes/",
                text: "Styled Boxes",
                src: StyledBoxes,
            },
            {
                link: "/style-my-wardrobe/",
                text: "Style My Wardrobe",
                src: StyleMyWardrobe,
            },
        ],
    },
    {
        text: "Shop Wear That x Tamara",
        flyout_links: null,
        src: null,
        link: `https://shop.wearthat.me/tamara`,
    },
    {
        text: "refer & earn",
        flyout_links: [
            {
                link: `/referral`,
                text: "Invite A Friend",
                src: InviteFriend,
            },
            {
                link: `/ambassador-program`,
                text: "Join Our Ambassadors",
                src: JoinOurAmbassadors,
            },
        ],
    },
    {
        link: `/blogs`,
        text: "Blog",
        src: BlogsIcon,
        flyout_links: null,
    },
    {
        link: `/gift-card/`,
        text: "Gift Card",
        src: GiftCard,
        flyout_links: null,
    },
];

export const LANGUAGE_BUTTON_TEXT = "Change Language ﺍﻟﹿﻌﹷﺮﹶﺑﻴﹽﺔ";
export const LANGUAGE_BUTTON_TEXT_ARABIC = "تغيير اللغة English";

export function slugify(string) {
    return string
        .toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "_");
}

export const HEADER_GIFT_CARD_BUTTON_ID = "header_gift_card_button_id";
export const HEADER_LOGIN_BUTTON_ID = "header_login_button_id";
export const CHANGE_LANGUAGE = "change_language";
export const MENU_ICON_ALT = "Menu Icon";
export const CLOSE_ICON_ALT = "close Icon";
export const LAZY = "lazy";
